import {Box, Paper} from "@mui/material";
import React, {useEffect, useState} from "react";
import DetailService from "../../../../../API/orders/cutting/detail/DetailService";
import DetailTable from "../../../../../components/UI/table/cutting/details/DetailTable";
import {useLocation, useParams} from "react-router-dom";
import Typography from "@mui/material/Typography";
import DetailUtil from "../../../../../utils/cutting/DetailUtil";
import MaterialsUtil from "../../../../../utils/warehouse/MaterialsUtil";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";
import {ModalSelectAction} from "../../../../../components/UI/modal/ModalSelectAction";
import ButtonSelectAction from "../../../../../components/UI/button/ButtonSelectAction";
import {constantsErrorMessages} from "../../../../../Constants";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import CircularProgress from "@mui/material/CircularProgress";
import {withFilter} from "../../../../../data/FilterTables/withFilterHOC";
import {DetailFilterData} from "../../../../../data/FilterTables/DetailFilterData";

const ComponentDetailWithFilter = withFilter(DetailTable, DetailFilterData);

const DetailsRequestsCuttingOptimization = () => {
    const pathname = useLocation().pathname
    const [rowSelection, setRowSelection] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [data, setData] = useState([]);
    const [unableCut, setUnableCut] = useState({});
    const [unableTurn, setUnableTurn] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const [modalStatusOpen, setModalStatusOpen] = useState(false);
    const [status, setStatus] = useState(true);
    const [typeStatus, setTypeStatus] = useState(null);
    const [change, setChange] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorIds, setErrorIds] = useState([]);
    const [materialList, setMaterialList] = useState(new Map());
    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`${pathname}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`${pathname}`]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    const params = useParams();
    const optimizationId = params.optimizationId;
    const number = params.number;

    useEffect(() => {
        getStartPageSize()
        DetailService.getAllByOptimizationId(optimizationId).then(function (response) {
            let data = response.data;
            setTableOptions((prev) => ({...prev, totalElements: data?.length}))
            const error = DetailUtil.checkDuplicatePositions(data, true);

            if (error.length > 0) {
                setIsError(true);
                setErrorIds(error)
            }
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            }).finally(() => setIsLoading(false))
    }, [change]);
    const modalActions = [
        {name: "Создать TXT файл", type: "txt"},
    ]
    const handleSelectAction = (type) => {
        setOpen(false)
        DetailService.createTXTFileSelco(selectedIds, number)
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', number);
                document.body.appendChild(link);
                link.click();
                handleModalAlert("TXT файл создан", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Детали на раскрой оптимизации ${number}`}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Оптимизации", href: "/organization/optimizations"},
                ]}/>
            <Typography variant="h6" component="h6">
                Детали на раскрой оптимизации {number}
            </Typography>
            {isLoading ?
                <Box sx={{
                    height: `calc(100vh - 570px)`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress disableShrink/>
                </Box> :
                <ComponentDetailWithFilter
                    data={data}
                    setData={setData}
                    unableCut={unableCut}
                    unableTurn={unableTurn}
                    setUnableCut={setUnableCut}
                    setUnableTurn={setUnableTurn}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    modalStatusOpen={modalStatusOpen}
                    setModalStatusOpen={setModalStatusOpen}
                    status={status}
                    setStatus={setStatus}
                    typeStatus={typeStatus}
                    setTypeStatus={setTypeStatus}
                    isColumnMaterial={true}
                    isColumnOrder={true}
                    warehouse={'orders'}
                    enableGrouping={true}
                    columnGrouping={['materialOptionOrganizationName']}
                    expanded={true}
                    isRedirectOptimizations={true}
                    isRedirectPlans={true}
                    isOptimization={true}
                    optimizationId={optimizationId}
                    change={change}
                    setChange={setChange}
                    isError={isError}
                    materialList={Array.from(materialList.values())}
                    enableRowSelection={false}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    isButtonRunModify={true}
                    enableEditing={true}
                    handleModalAlert={handleModalAlert}
                    params={params}
                    viewingAvailable={false}
                    errorIds={errorIds}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />}
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
            </Paper>}
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                autoHide={false}
            />
        </Box>
    );
};

export default DetailsRequestsCuttingOptimization;